import CallServer from '../../api/CallServerV2';
export async function fetchBiToken () {
    return await CallServer({
        endpoint: '/admin/get_business_intelligence_url',
        retryIfFailed: true
    })
} 
